export default function DevelopersIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_68186_2896'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_68186_2896)'>
        <path
          d='M5.99972 16.6442L1.35547 12L5.99972 7.35574L7.05347 8.39999L3.46897 12L7.05347 15.6L5.99972 16.6442ZM10.2862 19.9827L8.86697 19.5365L13.7132 4.01724L15.142 4.46349L10.2862 19.9827ZM17.9997 16.6442L16.946 15.6L20.5305 12L16.946 8.39999L17.9997 7.35574L22.644 12L17.9997 16.6442Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
